// Интерфейс Правосвода: страница целиком рисуется по данным сервера (boot.ts), разделы переключаются без перезагрузки (router.ts).
import { createRoot } from "react-dom/client";
import { AdminApp } from "./admin/AdminApp";
import { App } from "./App";
import { AuthProblemPage } from "./pages/AuthProblemPage";
import { ChatPage } from "./pages/ChatPage";
import { DashboardPage } from "./pages/DashboardPage";
import { DocumentsPage } from "./pages/DocumentsPage";
import { MyPage } from "./pages/MyPage";
import { PrivacyPage } from "./pages/PrivacyPage";
import { SettingsPage } from "./pages/SettingsPage";
import { routeStore, startRouter } from "./router";
import { loadChats, loadFolders, loadSaved, loadUploaded, prefetchChats, useStore } from "./store";

// Списки загружаются сразу, до первой отрисовки: чат по ссылке /?start=calc:… ждёт именно эту загрузку.
loadSaved();
loadUploaded();
loadFolders();
loadChats().then(() => setTimeout(prefetchChats, 300));   // переписки — после первой отрисовки, чтобы её не задерживать
startRouter();

const PAGES = {
  chat: ChatPage, documents: DocumentsPage, my: MyPage, privacy: PrivacyPage, auth_problem: AuthProblemPage,
  dashboard: DashboardPage, settings: SettingsPage,
};

// Кабинет администратора — отдельное приложение со своим меню (admin/AdminApp.tsx), остальные разделы — в каркасе сайта.
function Routed() {
  const route = useStore(routeStore);
  if (route.page === "admin") return <AdminApp key={route.visit} />;
  const Page = PAGES[route.page as keyof typeof PAGES] || ChatPage;
  return <App><Page key={route.visit} /></App>;
}

createRoot(document.getElementById("root")!).render(<Routed />);
